<template>
    <div>
        <evaluations-list :title="'label_sideMenu_evaluation_administrator_evaluations_title'" :isReportsList="false" />
    </div>
</template>
<script >

import EvaluationsList from "../shared/EvaluationsList";

export default {
    name:"CreateEvaluation",
    components: {EvaluationsList}
}

</script >
